var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.planResources && _vm.planResources.length)?_c('div',{staticClass:"survey-note-form-resources"},[_c('b-card',[_c('ul',_vm._l((_vm.checkedPlanOptions),function(opt,index){return _c('li',{key:index},[_vm._v("\n                "+_vm._s(opt.value)+"\n            ")])}),0)])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }